import type { ReactElement, SVGProps } from "react";

/**
 * Two-star "sparkle" icon used to highlight promotional payment-plan callouts
 * (e.g. the lowest-market-price offer). Colour is inherited via `currentColor`.
 * Geometry mirrors the Figma source: a large star with a smaller one to its
 * upper-right, laid out in a 22×22 box.
 */
export function SparkleIcon(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g transform="translate(4.8 4.98)">
        <path
          d="M3.49681 11.7584C2.73836 12.2158 1.80358 11.5343 2.00713 10.6723L2.59586 8.17912C2.68155 7.81622 2.55822 7.43578 2.2759 7.19218L0.348126 5.52882C-0.323134 4.94962 0.0354693 3.8481 0.919055 3.77509L3.44662 3.56624C3.81671 3.53566 4.13937 3.30252 4.28461 2.96076L5.28409 0.608882C5.6291 -0.202961 6.77976 -0.202961 7.12477 0.608882L8.12425 2.96076C8.26949 3.30252 8.59216 3.53566 8.96224 3.56624L11.4898 3.77509C12.3734 3.8481 12.732 4.94962 12.0607 5.52882L10.133 7.19218C9.85064 7.43578 9.72731 7.81622 9.813 8.17912L10.4017 10.6723C10.6053 11.5343 9.6705 12.2158 8.91206 11.7584L6.72087 10.4369C6.40323 10.2453 6.00564 10.2453 5.68799 10.4369L3.49681 11.7584Z"
          fill="currentColor"
        />
      </g>
      <g transform="translate(14.81 1.87)">
        <path
          d="M1.36732 5.11405C1.13978 5.25127 0.859349 5.0468 0.920414 4.7882L1.23608 3.45141C1.26179 3.34254 1.22479 3.22841 1.14009 3.15533L0.104438 2.26172C-0.09694 2.08796 0.0106403 1.75751 0.275716 1.7356L1.63456 1.62332C1.74559 1.61415 1.84239 1.54421 1.88596 1.44168L2.421 0.182665C2.5245 -0.060888 2.8697 -0.0608885 2.97321 0.182664L3.50825 1.44168C3.55182 1.54421 3.64862 1.61415 3.75965 1.62332L5.11849 1.7356C5.38357 1.75751 5.49115 2.08796 5.28977 2.26172L4.25411 3.15533C4.16942 3.22841 4.13242 3.34254 4.15813 3.45141L4.47379 4.7882C4.53486 5.0468 4.25442 5.25127 4.02689 5.11405L2.85204 4.4055C2.75674 4.34803 2.63747 4.34803 2.54217 4.4055L1.36732 5.11405Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
